import React from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import { ImageStyled, PlaceholderWrapper } from './Image.styles';
/**
 * @param src: path to the image source
 * @param placeholderComponent: Functional component to display when there is no source specified
 * @param height/width: the height/width in px to display the image
 * @param enableZoom: whether or not to enable panning/scroll wheel zooming on the image
 * @param objectFit: defines objectFit CSS behavior on the image
 *
 * @returns A square frame containing the linked image or placeholder,
 * with optional support for zooming. Crops and fills images that are
 * not a square aspect ratio.
 */
const Image = ({ eventHandler = (_) => null, src, placeholder, height, width, enableZoom = false, zoomProps, ...props }) => {
    if (src) {
        let imageComponent = (React.createElement(ImageStyled, { src: src, height: height, width: width, ...props }));
        if (enableZoom) {
            imageComponent = (React.createElement(TransformWrapper, { disablePadding: true, centerOnInit: true, onZoomStart: () => eventHandler({ event: 'zoom' }), ...zoomProps },
                React.createElement(TransformComponent, null, imageComponent)));
        }
        return imageComponent;
    }
    else if (placeholder) {
        // Re-assigning placeholderComponent to Placeholder because react
        // is really strict about only rendering pascal cased variables.
        return (React.createElement(PlaceholderWrapper, { height: height, width: width, ...props }, placeholder));
    }
    else {
        console.warn('No source or placeholderComponent, returning null');
        return null;
    }
};
export default Image;
//# sourceMappingURL=Image.js.map